export default "__VITE_ASSET__fcee336a__"